<template>
  <div class="ui field">
    <div class="ui toggle checkbox" :class="{ indeterminate: value == null }" @click="toggleValue">
      <input :id="fieldId" type="checkbox" :checked="value" class="hidden" :disabled="disabled" />
      <label :for="fieldId" class="capitalize-fl">
        {{ label }}
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TriStateToggle',
  props: ['owner', 'propName', 'label', 'disabled'],
  computed: {
    value() {
      return this.owner[this.propName]
    },
    fieldId() {
      return this.propName + '-tristatetoggle'
    }
  },
  methods: {
    toggleValue($event) {
      if (!this.disabled) {
        const val = this.value
        // Transitions: null => true => false => null
        this.$set(this.owner, this.propName, val == null ? true : val === true ? false : null)
      }
      $event.preventDefault()
    }
  }
}
</script>

<style scoped></style>
